import  React, {useEffect} from "react";
import { useState, useContext } from "react";
import { makeStyles, Theme, createStyles } from "@mui/styles";
import classnames from "classnames";
import {
  FormControlLabel,
  Switch,
  Checkbox,
  Radio
} from "@mui/material";
import {ValueContext} from '~common/components/form-def-field-fc';
import {ICGFormControl} from '~common/components/icg-form-control';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      width: "100%",
    },
    yesNo: {
      width: 100,
    },
    isRequired: {
      color: 'red',
    },
    formControlLabel: {
      marginRight: "1px !important"
    }
  })
);

interface BooleanProps {
  fieldDefinition: any;
  policyMessages?: any;
  readOnlyOverride?: boolean;
}

export const BooleanField: React.FC<BooleanProps> = ({
  fieldDefinition,
  policyMessages,
  readOnlyOverride,
}) => {
  const classes = useStyles();    

  // Setting the inital value and setValue hook based on the context passed in from form def field, instead of useState
  // setBoolVal will pass the value up to the parent component that houses the context.
  const [boolVal, setBoolVal] = useContext(ValueContext);

  const onChange = (event) => {
    setBoolVal(!boolVal);
  }

  const disabled = fieldDefinition.mode == "Read Only" || fieldDefinition.mode == "Display" || readOnlyOverride

  // required attribute does not work in the context being used so this is in place
  const requiredAsteriscs = (<span className={classnames("MuiFormLabel-asterisk", classes.isRequired)}>*</span>)
  
  var styleAttributes = fieldDefinition.styleAttributes || {};

  var control: any;

  control = (
    <Switch
      id={fieldDefinition.key}
      name={fieldDefinition.key}
      checked={boolVal && boolVal == true ? true : false}
      onChange={onChange}
      value={boolVal}
      color="primary"
      disabled={disabled}
    />
  )

  switch (fieldDefinition.variant) {
    case "Checkbox":
      control = (
        <Checkbox
          inputProps={{
            name: fieldDefinition.key,
          }}
          checked={boolVal}
          onChange={onChange}
          value={fieldDefinition.key}
          color="primary"
          disabled={disabled}
        />
      )
      break
    case "Radio":
      control = (
        <Radio
            inputProps={{
              name: fieldDefinition.key,
            }}
            checked={boolVal}
            onChange={onChange}
            value={fieldDefinition.key}
            color="primary"
            disabled={disabled}
          />
      )
      break
  }

  return (
    <ICGFormControl suppressLabel={true} fieldDefinition={fieldDefinition} policyMessages={policyMessages} readOnlyOverride={readOnlyOverride}>
      <div style={styleAttributes}>
       <FormControlLabel
         className={classes.formControlLabel}
         control={
          control
         }
         label={fieldDefinition.title || ""}
       />{fieldDefinition.mode == "Required" ? requiredAsteriscs : null}
       </div> 
    </ICGFormControl>
  )
};

export default BooleanField;
